import { InjectionToken } from '@angular/core';
import { IEnvironment } from '../interface';

export const PULSE_ENVIRONMENT: InjectionToken<IEnvironment> = new InjectionToken<IEnvironment>('Pulse Environment');
